/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoadChainageDto } from '../../models/load-chainage-dto';

export interface UpdateLoadChainage$Params {
  id: string;
      body: LoadChainageDto
}

export function updateLoadChainage(http: HttpClient, rootUrl: string, params: UpdateLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadChainageDto>> {
  const rb = new RequestBuilder(rootUrl, updateLoadChainage.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadChainageDto>;
    })
  );
}

updateLoadChainage.PATH = '/v1/loadchainages/{id}';
